import Image, { ImageProps } from 'next/image'
import { useState } from 'react'

export const NaturalImage = ({
  width = 400,
  height = 400,
  alt,
  fill,
  ...props
}: ImageProps) => {
  const [imageRatio, setImageRatio] = useState(4 / 5)

  const internalHeight = parseInt(height.toString()) / imageRatio

  return (
    <Image
      width={!fill ? width : undefined}
      height={
        !fill
          ? height && !isNaN(internalHeight)
            ? internalHeight
            : height
          : undefined
      }
      onLoadingComplete={({ naturalWidth, naturalHeight }) => {
        setImageRatio(naturalWidth / naturalHeight)
      }}
      alt={alt}
      fill={fill}
      {...props}
    />
  )
}
